<script setup lang="ts">
import { DropdownMenuContent, type DropdownMenuContentEmits, type DropdownMenuContentProps, DropdownMenuPortal, useForwardPropsEmits } from 'reka-ui'
import { computed, type HTMLAttributes } from 'vue'

import { cn } from '../../../lib/utils'

// eslint-disable-next-line unicorn/prevent-abbreviations, vue/require-default-prop
const props = withDefaults(defineProps<DropdownMenuContentProps & { class?: HTMLAttributes['class']; align?: DropdownMenuContentProps['align'] }>(), {
  sideOffset: 4,
})
const emits = defineEmits<DropdownMenuContentEmits>()

const delegatedProperties = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwarded = useForwardPropsEmits(delegatedProperties, emits)
</script>

<template>
  <DropdownMenuPortal>
    <DropdownMenuContent v-bind="forwarded" :class="cn('atabix-dropdown-menu__content', props.class)">
      <slot />
    </DropdownMenuContent>
  </DropdownMenuPortal>
</template>

<style lang="scss">
.atabix-dropdown-menu__content {
  @apply z-10;
  @apply min-w-32;
  @apply overflow-hidden;
  @apply rounded-md;
  @apply border;
  @apply bg-background;
  @apply p-1;
  @apply text-foreground;
  @apply shadow-md;
  @apply data-[state=open]:animate-in;
  @apply data-[state=closed]:animate-out;
  @apply data-[state=closed]:fade-out-0;
  @apply data-[state=open]:fade-in-0;
  @apply data-[state=closed]:zoom-out-95;
  @apply data-[state=open]:zoom-in-95;
  @apply data-[side=bottom]:slide-in-from-top-2;
  @apply data-[side=left]:slide-in-from-right-2;
  @apply data-[side=right]:slide-in-from-left-2;
  @apply data-[side=top]:slide-in-from-bottom-2;
}
</style>
